import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-operation-menu',
  templateUrl: './operation-menu.component.html',
  styleUrls: ['./operation-menu.component.css']
})
export class OperationMenuComponent implements OnInit {
    operationId;

    public menu?: Menu;

    public operationNameButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'operationlangs', gotoParms: () => this.menu!.operation_id ?? '' }
    ];

    public prodIdButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'product', gotoParms: () => this.menu!.prod_keyno ?? '' }
    ];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.operationId = this.stateService.getStateParams()['operation_id'];
    }

    private async loadMenu() {
        if (!!this.operationId) {
            this.menu = (await this.datatask.Post(2035, { operation_id: this.operationId }))[0];
        }
    }

    private async init() {
        this.loadMenu();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    operation_id: string;
    operation_name: string;
    direct: number;
    unit_no: number;
    cost_pr_unit: string;
    note: string;
    active: number;
    prod_id: string;
    prod_name: string;
    unitname: string;
    nbr_of_possible_equipments: number;
    nbr_of_suboperations: number;
    use_suboperations: string;
    prod_keyno: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('operationMenu', {
//        templateUrl: 'views/components/views/operationMenu/operationMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'operationMenuService', function ($stateParams, stateService, operationMenuService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let operationId = $stateParams.operation_id;

//            vm.model = {
//                operationNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('operationlangs', { operation_id: vm.model.menu.operation_id }) }
//                ],
//                prodIdButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('product', { prod_id: vm.model.menu.prod_keyno }) }
//                ],
//                menu: {}
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadMenu() {
//                vm.model.menu = (await operationMenuService.getMenu({ operation_id: operationId }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadMenu();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
